// src/components/Base64Image.tsx (or wherever it is)
import React, { useEffect, useState , CSSProperties } from "react";
import { Image } from "primereact/image";

interface Base64ImageProps {
  imageUrl: string;
  className?: string;
  alt?: string;
  height?:string;
  style?: CSSProperties;
}

const Base64Image: React.FC<Base64ImageProps> = ({ imageUrl, className = "", alt = "image", height="",  style = {}, }) => {
  const [base64, setBase64] = useState("");

  useEffect(() => {
    const convertToBase64 = async () => {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          setBase64(reader.result as string);
        };
        reader.readAsDataURL(blob);
      } catch (err) {
        console.error("Image load error", err);
      }
    };

    if (imageUrl) convertToBase64();
  }, [imageUrl]);

  return base64 ? <Image src={base64} alt="Insurance Image" className={className} height={height} style={style}/>: null;
};

export default Base64Image;
